// extracted by mini-css-extract-plugin
export default {"products":"wv-z","card":"xv-z","oosMessaging":"yv-z"};